import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Stack,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
  styled,
} from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import BoltIcon from "@mui/icons-material/Bolt";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CloseIcon from "@mui/icons-material/Close";
import { ToastContainer } from "react-toastify";
import { progressData } from "./ProgressData";
import { useCheckpointUpdateMutation } from "../../app/services/quizCore";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(90deg, hsla(217, 100%, 50%, 1) 0%, hsla(186, 100%, 69%, 1) 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    [theme.breakpoints.down("md")]: {
      height: 25,
      width: 3,
      margin: 10,
    },
    [theme.breakpoints.up("md")]: {
      height: 3,
      width: "100%",
    },

    width: 0,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  cursor: "pointer",
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient(90deg, hsla(217, 100%, 50%, 1) 0%, hsla(186, 100%, 69%, 1) 100%)",
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <BoltIcon />,
    2: <WhatsAppIcon />,
    3: <EmojiEventsIcon />,
    4: <LinkedInIcon />,
    5: <EmojiEventsIcon />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

export default function CustomizedSteppers(props) {
  const windowSize = React.useRef([window.innerWidth, window.innerHeight]);
  const [openDialog, setOpenDialog] = React.useState(false);

  const [
    checkpointApiCall,
    { data: dataCheckpoint, isLoading, isError, isSuccess, error },
  ] = useCheckpointUpdateMutation();

  useEffect(() => {
    handleCloseDialog();
    if (isSuccess) {
      window.location.reload();
    } else if (isError) {
      alert(error);
    }
  }, [isLoading, isSuccess, isError]);

  const handleOpenDialog = (index) => {
    setProData(progressData[index]);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const submitLink = (e) => {
    e.preventDefault();
    checkpointApiCall({
      email: props.data.email,
      checkpoint: prodata.checkpoint,
      link: selectedFile !== null ? selectedFile.name : link,
    });
  };

  const [prodata, setProData] = React.useState(progressData[0]);
  const [link, setLink] = React.useState("");
  const [selectedFile, setSelectedFile] = React.useState(null);

  const onFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  return (
    <Box>
      <Dialog
        fullWidth={false}
        maxWidth={"md"}
        open={openDialog}
        onClose={handleCloseDialog}
      >
        <DialogTitle
          style={{
            backgroundColor: "rgb(111, 99, 230)",
            color: "rgb(255, 255, 255)",
            textTransform: "capitalize",
            position: "relative",
          }}
        >
          {prodata.title}
          <CloseIcon
            sx={{ position: "absolute", top: 20, right: 20, cursor: "pointer" }}
            onClick={handleCloseDialog}
          />
        </DialogTitle>

        <DialogContent
          style={{
            backgroundColor: "rgb(111, 99, 230)",
          }}
        >
          <DialogContentText
            id="alert-dialog-description"
            style={{
              color: "rgb(255, 255, 255)",
              whiteSpace: "pre-line",
            }}
          >
            {prodata.desp}
          </DialogContentText>
          <br />
          {prodata.showTextField && (
            <DialogContentText
              id="alert-dialog-description"
              style={{
                color: "rgb(255, 255, 255)",
              }}
            >
              <b>
                Copy the
                {prodata.checkpoint === "LP1"
                  ? " WhatsApp message "
                  : prodata.checkpoint === "LP2"
                  ? " LinkedIn Post "
                  : ""}
                from -
              </b>
              <br />
              <a href={prodata.link} target="_blank" style={{ color: "white" }}>
                {prodata.link}
              </a>
              <br />
              <br />
              <span style={{ whiteSpace: "pre-line" }}>{prodata.message}</span>
              <form>
                {prodata.checkpoint === "LP1" ? (
                  <>
                    <Button variant="contained" component="label">
                      Upload
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={onFileChange}
                      />
                    </Button>
                    {selectedFile && (
                      <span style={{ margin: "5%" }}>{selectedFile.name}</span>
                    )}
                  </>
                ) : (
                  <input
                    type="text"
                    style={{
                      border: "none",
                      borderRadius: "0.5rem",
                      width: "100%",
                      outline: "none",
                      padding: "0.5rem",
                      color: "black",
                      marginBottom: "1rem",
                      marginTop: "1rem",
                    }}
                    onChange={(e) => setLink(e.target.value)}
                  />
                )}

                <Button
                  onClick={submitLink}
                  variant="contained"
                  disabled={
                    (prodata.checkpoint === "LP2" &&
                      props.data.checkpoint !== 2) ||
                    (prodata.checkpoint === "LP1" && props.data.checkpoint > 1)
                  }
                  sx={{
                    background: "#362b88",
                    float: "right",
                    "&:hover": {
                      background: "#362b88",
                    },
                  }}
                >
                  Submit
                </Button>
              </form>
            </DialogContentText>
          )}
        </DialogContent>
      </Dialog>

      <Stack sx={{ width: "100%", padding: "2% 5%" }} spacing={4}>
        <Stepper
          alternativeLabel={windowSize.current[0] < 900 ? false : true}
          orientation={windowSize.current[0] < 900 ? "vertical" : "horizontal"}
          activeStep={props.data?.checkpoint}
          connector={<ColorlibConnector />}
        >
          <Step onClick={() => handleOpenDialog(0)}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              <Typography sx={{ color: "white", fontWeight: "300" }}>
                Start Journey
              </Typography>
            </StepLabel>
          </Step>

          <Step onClick={() => handleOpenDialog(1)}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              <Typography sx={{ color: "white", fontWeight: "300" }}>
                Send WhatsApp <br />
                Message
              </Typography>
            </StepLabel>
          </Step>

          <Step onClick={() => handleOpenDialog(2)}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              <Typography sx={{ color: "white", fontWeight: "300" }}>
                Get JobReadyPro
                <br /> for FREE!!
              </Typography>
            </StepLabel>
          </Step>

          {/* <Step onClick={() => handleOpenDialog(3)}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              <Typography sx={{ color: "white", fontWeight: "300" }}>
                Post on LinkedIn
              </Typography>
            </StepLabel>
          </Step>

          <Step onClick={() => handleOpenDialog(4)}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              <Typography sx={{ color: "white", fontWeight: "300" }}>
                Unlock Guaranteed Internship & Placement Opportunities
              </Typography>
            </StepLabel>
          </Step> */}
        </Stepper>
      </Stack>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"
        pauseOnHover
      />
    </Box>
  );
}
